import { render } from "./MapPointWidgetOl.vue?vue&type=template&id=449b1e06"
import script from "./MapPointWidgetOl.vue?vue&type=script&lang=js"
export * from "./MapPointWidgetOl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__